import { DefaultListParams } from "../types/DefaultListParams";

export const cleanParams = <
  T extends DefaultListParams | Record<string, unknown>,
>(
  params: T,
) => {
  const cleanedParams = params;

  Object.keys(cleanedParams).forEach((key) => {
    const value = cleanedParams[key];
    if (
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0)
    ) {
      delete cleanedParams[key];
    }
  });

  return cleanedParams;
};
